import '../assets/css/nosotros.css';
import nosotros from '../assets/nosotros.jpg';
import {FaWhatsapp, FaInstagram, FaFacebookF} from 'react-icons/fa'

function Nosotros(){
    return(
        <>
            
            <section className="sobre_nosotros container">
                <div className="sobre_nosotros__contenido">
                    <h2 className="sobre_nosotros__titulo" id="sobre-nosotros">Sobre nosotros</h2>
                    <p className="sobre_nosotros__texto">
                        <b>Tapiceria en general, automotor y antiguedades</b>
                    </p>
                    <p className="sobre_nosotros__texto">
                        Somos Tapicería "M&Z tapizados", una empresa familiar ubicada en el 
                        barrio de José Mármol, provincia de Buenos Aires. Contamos con más de 
                        20 años de experiencia ofreciendo servicios de tapizado y retapizados 
                        para todo tipo de mobiliario, sillones, tapizados coorporativos, 
                        butacas, sofas, automotor, clásicos y modernos. 
                        Trabajamos intensamente para brindarle calidad, atención y buen 
                        servicio, es por eso que nos adaptamos a todo tipo de gustos y 
                        necesidades de nuestros clientes. Escuchamos sus peticiones y 
                        basandonos en ellas les ofrecemos un servicio que supere todas sus 
                        expectativas.
                    </p>
                    <p className="sobre_nosotros__texto sobre-nosotros__texto--destacado sobre-nosotros__texto--division">
                        ¡Utilizamos materia prima de primera calidad!
                    </p>
                    <p className="sobre_nosotros__texto"><b>¡Seguinos en las redes!</b> <span className="sumate"><b>Pedí tu presupuesto sin cargo!</b></span></p>
                    <div className='sobre_nosotros__icon'>
                        <a href='https://wa.me/111541872661' target='__blank'><FaWhatsapp size={60} className='icon'/></a>
                        <a href='https://www.instagram.com/myztapizados/' target='__blank'><FaInstagram size={60} className='icon'/></a>
                        <a href='https://www.facebook.com/profile.php?id=100085047979424&mibextid=2JQ9oc' target='__blank'><FaFacebookF size={60} className='icon'/></a> 
                    </div>
                </div>
                <img src={nosotros} alt="Sobre Nosotros" className="sobre_nosotros__imagen"/>
            </section>
        </>
    )
}

export default Nosotros;